<template>
  <div class="step-informacoes">
    <div class="form-group">
      <label class="field-label">Descrição</label>
      <input
        class="form-control form-control-sm"
        maxlength="250"
        v-model="item.descricao"
        :disabled="isErpLocked"
        placeholder="Nome da campanha"
      />
      <div v-if="validacao.firstError('item.descricao')" class="message">{{ validacao.firstError("item.descricao") }}</div>
    </div>

    <CRow>
      <CCol md="6">
        <div class="form-group">
          <label class="field-label">Data de início</label>
          <datetime
            inputId="dtIni"
            input-class="form-control form-control-sm"
            type="date"
            v-model="item.dataInicio"
            :max-datetime="item.dataFim"
            :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
            value-zone="local"
            format="d/M/y"
            :disabled="isErpLocked"
          />
          <div v-if="validacao.firstError('item.dataInicio')" class="message">{{ validacao.firstError("item.dataInicio") }}</div>
        </div>
      </CCol>
      <CCol md="6">
        <div class="form-group">
          <label class="field-label">Data de término</label>
          <datetime
            :disabled="item.dataFim === null || isErpLocked"
            inputId="dtFim"
            input-class="form-control form-control-sm"
            type="date"
            :min-datetime="item.dataInicio"
            v-model="item.dataFim"
            :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
            value-zone="local"
            format="d/M/y"
          />
          <div v-if="validacao.firstError('item.dataFim')" class="message">{{ validacao.firstError("item.dataFim") }}</div>
        </div>
      </CCol>
    </CRow>

    <div class="form-group">
      <label class="field-label">Descreva o funcionamento da campanha</label>
      <textarea
        rows="3"
        class="form-control form-control-sm"
        v-model="item.funcionamento"
        :disabled="isErpLocked"
        placeholder="Explique como a campanha funciona para o operador..."
      />
      <div v-if="validacao.firstError('item.funcionamento')" class="message">
        {{ validacao.firstError("item.funcionamento") }}
      </div>
    </div>

    <div class="step-informacoes__section">
      <div class="section-label">Aplicar nos sistemas</div>
      <div class="step-informacoes__canais-grid">
        <SelectableCard
          v-for="canal in canais"
          :key="canal.key"
          :value="canal.key"
          :label="canal.label"
          :icon="canal.icon"
          :selected="item[canal.key]"
          :disabled="isErpLocked"
          @select="toggleCanal(canal.key)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SelectableCard from "../shared/SelectableCard.vue";
import { CANAIS } from "../helpers/campanhaLabels";

export default {
  name: "StepInformacoes",
  components: { SelectableCard },
  props: {
    item: {
      type: Object,
      required: true,
    },
    validacao: {
      type: Object,
      required: true,
    },
    isErpLocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      canais: CANAIS,
    };
  },
  methods: {
    toggleCanal(key) {
      this.$set(this.item, key, !this.item[key]);
    },
  },
};
</script>

<style scoped>
.step-informacoes .form-group {
  margin-bottom: 10px;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.message {
  font-size: 11px;
  color: #d92d20;
  margin-top: 2px;
}

.step-informacoes__section {
  margin-top: 12px;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.step-informacoes__canais-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

@media (max-width: 768px) {
  .step-informacoes__canais-grid {
    grid-template-columns: 1fr;
  }
}
</style>
